import {sortByPosition} from 'nutshell-core/utils/sorting/sort-by-position';

import type {EmailComposerFormSequenceState} from './types';

/**
 * Helper function to get the subject from the first email in a sequence.
 * We'll display this in the minimized modal bar.
 *
 * @param  {Object} sequence     - Full email sequence from form state
 * @return {string}              - Primary email subject
 */
export function getSequencePrimarySubject(sequence: EmailComposerFormSequenceState) {
    const sortedTemplates = sortByPosition(sequence.emailTemplates);

    // @ts-expect-error
    return sortedTemplates[0].subject || 'Untitled message';
}
